import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/seller-product-price-confirmation/constants'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Seller Product Price Confirmation `status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} status Seller Product Price Confirmation status. available values
 * - `seller_confirmed`
 * - `pending`
 */
const PriceConfirmationStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.SELLER_CONFIRMED] : 'primary',
    [STATUS.PENDING]          : 'warning'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

PriceConfirmationStatusBadge.propTypes = propTypes

export default PriceConfirmationStatusBadge
